/**
 * Props for SkeletonElement component - a base building block for skeleton loaders
 * @param width - Width as string (e.g., "100%", "w-1/3") or number (percentage)
 * @param height - Height as Tailwind class (e.g., "h-4", "h-8")
 * @param rounded - Border radius style (default: "rounded-lg")
 * @param className - Additional CSS classes
 * @param data-testid - Test ID for testing
 */
type SkeletonElementProps = {
  width?: string | number;
  height?: string;
  rounded?: "rounded-full" | "rounded-lg" | "rounded-md" | "rounded-sm" | string;
  className?: string;
  "data-testid"?: string;
};

export default function SkeletonElement({
  width,
  height = "h-4",
  rounded = "rounded-lg",
  className = "",
  "data-testid": dataTestId
}: SkeletonElementProps) {
  const widthClass = typeof width === "string" ? width : "";
  const widthStyle = typeof width === "number" ? { width: `${width}%` } : undefined;

  return (
    <div
      className={`animate-pulse ${height} ${rounded} bg-gradient-to-r bg-sys-brand-surface-container-highest bg-sys-brand-surface-low ${widthClass} ${className}`}
      style={widthStyle}
      data-testid={dataTestId}
    />
  );
}
